import { intlLocaleFor } from "./formatMoney";

/**
 * Which i18n key a count takes. The repo's convention is one key per plural form (`...One`
 * beside the base key, see `msg.unreadOne`); this decides WHICH form a count takes in each
 * language from the CLDR rules (`Intl.PluralRules`) instead of `n === 1`, so French reads
 * "0 transaction" / "1 transaction" / "2 transactions" while English and Spanish read
 * "0 transactions" / "1 transaction".
 *
 * `lang` comes from `LanguageContext` and is NOT trusted: `new Intl.PluralRules("xx-")` throws
 * a RangeError and would take the page down. It goes through `intlLocaleFor`, the allow-list
 * every other formatter uses, which maps an unknown value to the English fallback.
 *
 * pluralKey("fr", 0, "ctx.totalCount") -> "ctx.totalCountOne"
 * pluralKey("en", 0, "ctx.totalCount") -> "ctx.totalCount"
 */
export const pluralKey = (lang, n, baseKey) =>
  new Intl.PluralRules(intlLocaleFor(lang)).select(n) === "one" ? `${baseKey}One` : baseKey;
